class CartUpsells extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      threshold: 0,
    })

    this.observer.observe(this)
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    this.setupGrapheneUpsells()

    observer.unobserve(this)
  }

  setupGrapheneUpsells () {
    if (typeof graphenehc !== 'undefined') {
      let customerType = 'standard'

      if (this.dataset.customerType === true) {
        customerType = 'trade'
      }
      // eslint-disable-next-line no-undef
      graphenehc.load({
        elements: [
          {
            id: this.dataset.grapheneId,
            target: '[data-graphene-upsells-el="push-cart-aside"]',
          },
          {
            id: this.dataset.grapheneId,
            target: '[data-graphene-upsells-el="push-cart-items"]',
          },
        ],
        args: { customer_type: customerType },
        page_context: {
          product_id: this.dataset.productId,
          currency_id: window.Shopify.country,
        },
        success () {
          window.BAO.dispatchEvent(window.BAO.EVENTS.WISHLIST.CHECK_WISHLIST)
        },
      })
    }
  }
}

if (!customElements.get('cart-upsells')) {
  customElements.define('cart-upsells', CartUpsells)
}
